<div class="chart">
    <apx-chart
        [series]="chartOptions.series!"
        [chart]="chartOptions.chart!"
        [dataLabels]="chartOptions.dataLabels!"
        [title]="chartOptions.title!"
        [yaxis]="chartOptions.yaxis!"
        [xaxis]="chartOptions.xaxis!"
        [grid]="chartOptions.grid!"
        [colors]="chartOptions.colors!"
    ></apx-chart>
</div>